import { render, staticRenderFns } from "./TransferStoreFormActionModal.vue?vue&type=template&id=24c0d1bb"
import script from "./TransferStoreFormActionModal.vue?vue&type=script&lang=js"
export * from "./TransferStoreFormActionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports